import {
  ReadBillByIdRequest,
  ReadBillByIdResponse,
  ReadBillsByEntityRequest,
  ReadBillsByEntityResponse,
} from '@eigtech/invoicing-types'
import { contextualGet, queryOptions, useQuery, useSuspenseQuery } from '@eigtech/ui-shared-api'
import { billQueryKeys, invoicingBasePath } from './constants'

async function getBillsForEntity({ entityId }: ReadBillsByEntityRequest) {
  const { bills } = await contextualGet<ReadBillsByEntityResponse>(
    `${invoicingBasePath}/${entityId}/bill`
  )

  return bills
}

export const getBillsForEntityQueryOptions = (request: ReadBillsByEntityRequest) =>
  queryOptions({
    queryKey: billQueryKeys.list(request),
    queryFn: () => getBillsForEntity(request),
  })

export const useGetBillsForEntity = (request: ReadBillsByEntityRequest) =>
  useQuery(getBillsForEntityQueryOptions(request))

export const useGetBillsForEntitySuspense = (request: ReadBillsByEntityRequest) =>
  useSuspenseQuery(getBillsForEntityQueryOptions(request))

/* ------------------------------------------------------------------------------------------- */

async function getBill({ entityId, billId }: ReadBillByIdRequest) {
  const { bill } = await contextualGet<ReadBillByIdResponse>(
    `${invoicingBasePath}/${entityId}/bill/${billId}`
  )

  return bill
}

export const getBillQueryOptions = (request: ReadBillByIdRequest) =>
  queryOptions({
    queryKey: billQueryKeys.detail(request),
    queryFn: () => getBill(request),
  })

export const useGetBill = (request: ReadBillByIdRequest) => useQuery(getBillQueryOptions(request))

export const useGetBillSuspense = (request: ReadBillByIdRequest) =>
  useSuspenseQuery(getBillQueryOptions(request))
